import qs from "qs";
import * as axiosHelper from "../api_helper";

export const downloadForexReportAPI = async (params) => {
  return axiosHelper.get(`/fxtransactions/download?${qs.stringify(params)}`, {
    responseType: "blob",
  });
};

export const downloadWalletReportAPI = async (params) => {
  return axiosHelper.get(`/wallet/report/download?${qs.stringify(params)}`, {
    responseType: "blob",
  });
};
